module.exports = __webpack_public_path__ + "img/p1.fd11b3e5.png";